export default {"src":"/_next/static/media/tta_1.5b768820.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};